import {
  GLOBAL_STEP_ORDER,
  MAIN_PROCESS_STEPS,
  SCAN_PROCESS_STEPS,
} from '../../shared/constants/flowConfig';

/** Bump when snapshot schema changes. */
export const STEP_CHECKPOINT_SCHEMA_VERSION = 1;

/** Steps that participate in in-session mesh/tool checkpoints. */
export const CHECKPOINT_STEP_ORDER = GLOBAL_STEP_ORDER;

/** Preview steps: capture mesh snapshot on enter (not only when leaving). */
export const ON_ENTER_CAPTURE_STEPS = [
  SCAN_PROCESS_STEPS.FINAL_DESIGN_PREVIEW,
  MAIN_PROCESS_STEPS.CLINICAL_MODIFICATION_PREVIEW,
];

export function isCheckpointStep(stepId) {
  return CHECKPOINT_STEP_ORDER.includes(stepId);
}

export function isOnEnterCaptureStep(stepId) {
  return ON_ENTER_CAPTURE_STEPS.includes(stepId);
}
